import React, { useEffect, useState } from "react";
import { BackToTop, Footer, NavItem, NavMenu, ToggleButton } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ModelCard, ModelGrid, ModelImage, ModelInfo, ModelName } from "../Negros/styles";
import { TrajesAzulesContainer } from "./styles";

const Azules = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        };

        window.addEventListener("scroll", handleScroll)

        return () => window.removeEventListener("scroll", handleScroll)

    }, []);

    useEffect(() => {
            if(collapsed) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
    
            return () => {
                document.body.style.overflow = "auto";
            };
        }, [collapsed])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    };

    return (
        <>
            <TrajesAzulesContainer>
                <p>Trajes azules</p>
                <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButton>

                <NavMenu collapsed={collapsed}>
                    <NavItem
                        onClick={() => navigate("/")}
                        active = {location.pathname === "/"}
                    >
                        Inicio
                    </NavItem>

                    <NavItem
                        active={location.pathname.startsWith("/trajes")}
                        onClick={() => navigate("/trajes")}
                    >
                        Trajes
                    </NavItem>

                    <NavItem
                        active = {location.pathname === '/smokings'}
                        onClick={() => navigate("/smokings")}
                    >
                        Smokings
                    </NavItem>

                    <NavItem
                        active = {location.pathname === '/togas'}
                        onClick={() => navigate("/togas")}
                    >
                        Togas
                    </NavItem>
                    <NavItem>
                        <a
                            href="/catalogo-trajes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
            </TrajesAzulesContainer>

            <ModelGrid>
                <ModelCard>
                    <ModelImage 
                        src="/img/Marino.jpg" alt="Marino"
                        onClick={() => navigate("/trajes/azules/marino")}/>
                    <ModelInfo>
                        <ModelName>Marino</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Genova.jpg" alt="Genova"
                        onClick={() => navigate("/trajes/azules/genova")}    
                    />
                    <ModelInfo>
                        <ModelName>Génova</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Italia.jpg" alt="Italia"
                        onClick={() => navigate("/trajes/azules/italia")}
                    />
                    <ModelInfo>
                        <ModelName>Italia</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Francia.jpg" alt="Francia"
                        onClick={() => navigate("/trajes/azules/francia")}
                        />
                    <ModelInfo>
                        <ModelName>Francia</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Napoles.jpg" alt="Napoles"
                        onClick={() => navigate("/trajes/azules/napoles")}    
                    />
                    <ModelInfo>
                        <ModelName>Nápoles</ModelName>
                    </ModelInfo>
                </ModelCard>


            </ModelGrid>
            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Azules;